import ReservationReportIndex from "@/views/report/reservation/ReservationReportIndex.vue";
const reservationReport = [
    {
        path: '/reservation-report',
        name: 'reservation-report',
        component: ReservationReportIndex
    }
]

export default reservationReport;